import { ThemeProvider } from '@mui/styles';
import React, { Component } from 'react';
import { Link } from 'react-router-dom';
import CircularLoading from "../components/CircularLoading";
import { Me, SetToken, SetUser } from '../services/Session';
import '../styles/style.css';
import theme from '../styles/theme';

const qs = require('query-string')
const BackIcon = '/assets/svg/back.svg'

class Session extends Component {
	constructor(props) {
		super(props)
		this.setSession()
	}

	setSession = () => {
		let token = (qs.parse(this.props.location.search)) ? qs.parse(this.props.location.search).token : ''
		Me(SetToken(token).access_token).then(res => {
			SetUser(res.data)
			if (typeof res.data.gender!=='undefined' && (res.data.gender==='male' || res.data.gender==='female')) {
				setTimeout(this.props.history.push('/'), 3000)
			} else {
				setTimeout(this.props.history.push('/profil'), 3000)
			}
		})
	}

	render() {
		return (
			<ThemeProvider theme={theme}>
				<div className="header">
					<Link to="/" style={{ position: 'absolute', height: 60, width: 60, top: 0, left: 0 }} >
						<img alt="icon" src={BackIcon} />
					</Link>
					<div className="center"><h3 className="title">Masuk</h3></div>
				</div>
				<div className="wrapper-white">
					<CircularLoading />
				</div>
			</ThemeProvider>
		);
	}
}

export default Session
